
import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import ListItem from '@material-ui/core/ListItem'

import StyledPaper from '../StyledPaper'

const styles = theme => ({
  fullWidth: {width: '100%'},
  noPadding: {padding: 0},
  // FormControlLabel Overrides ( allows the label to fill entire Paper )
  formControlLabelRoot: {
    marginLeft: 0,
    marginRight: 0,
    padding: theme.spacing.unit * 2
  },
  labelText: {
    fontSize: '1.15rem'
  }
})

const Factor = ({ checked, classes, disabled, onFactorClick, text }) => (
  <ListItem disableGutters>
    <StyledPaper className={`${classes.fullWidth} ${classes.noPadding}`}>
      <FormControlLabel
        classes={{root: classes.formControlLabelRoot, label: classes.labelText}}
        className={`${classes.fullWidth}`}
        control={
          <Checkbox
            checked={checked}
            disabled={disabled}
            label={text}
            onClick={onFactorClick}
            value={text}
          />
        }
        label={text}
        style={styles.fullWidth}
      />
    </StyledPaper>
  </ListItem>
)

Factor.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onFactorClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
}

export default withStyles(styles)(Factor)


// WEBPACK FOOTER //
// ./src/components/counseling-session/top-three-factors/Factor.js